import pkg from '@package';

const rootDomain = location.hostname.includes('daas.consulting')
  ? 'dev.asserca.daas.consulting'
  : 'dev.asserca.com.ar';

let domain;
if (location.hostname.includes('production.')) {
  domain = `production.${rootDomain}`;
} else {
  domain = `${rootDomain}`;
}

export const environment = {
  local: false,
  dev: true,
  qas: false,
  prod: false,
  baseUrl: `https://bff.${domain}`,
  loginRedirect: `https://bff.${domain}/security/authentication/google`,
  appBase: '/',
  appBaseUrl: `https://app.${domain}`,
  bffBaseUrl: `https://bff.${domain}`,
  apiInternalBaseUrl: 'http://backend:8080',
  apiExternalBaseUrl: `https://api.${domain}`,
  version: pkg?.version || '1.0.0',
  borderColor: '#e67e22',
  borderWidth: '4px',
  name: 'DEV',
  loggerEnabled: true,
  logoUrl: 'assets/logo.png',
  companyName: 'Laboratorio Asserca S.R.L.',
  qrCodeAppTitle: 'Producción - Laboratorio Asserca:',
  license: 'Copyright © 2024 Laboratorio Asserca S.R.L.',
};
